exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-cell[data-v-1e2adb70]{border-bottom:1px solid hsla(0,0%,86.7%,.5215686274509804);font-size:.42rem}.van-cell .van-cell__title[data-v-1e2adb70]{display:-webkit-box;display:-ms-flexbox;display:flex;justify-items:flex-start;-webkit-box-flex:3;-ms-flex:3;flex:3}.van-cell .van-cell__value .van-checkbox[data-v-1e2adb70]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);

// exports
